import GhostElement from '@bpm-web-app/components/src/lib/shared/ghost-element/ghost-element';
import { useUniqueArray } from '@bpm-web-app/utils';
import styles from './list-loading.module.css';
import { ListWrapper } from '../list-wrapper/list-wrapper';

export function ListLoading() {
    const ghostLoadingItems = useUniqueArray(20);

    return (
        <ListWrapper>
            <div className={styles['list-loading']}>
                {ghostLoadingItems.map((uuid) => (
                    <GhostElement hasShimmer forMaxiPlayer isRow key={`loading-media-${uuid}`} itemClass={styles['list-loading__item']} linesWidthArray={[90, 70]} squareWidth={56} />
                ))}
            </div>
            ;
        </ListWrapper>
    );
}
